/**
 * 特殊條碼常數定義
 *
 * 這些條碼在 QC 流程中有特殊用途，不是一般的商品條碼
 */

export const SPECIAL_BARCODES = {
  // 觸發裝箱動作
  DO_PACKING: {
    code: '-DOPACKING-',
    alternativeCodes: ['DOPACKING'],
    label: '裝箱',
    description: '完成當前箱子的裝箱並開始新箱子',
    i18nKey: 'operator.qc.special_barcodes.do_parcel',
  },

  // 回報異常（退貨驗收用）
  REPORT_ANOMALY: {
    code: '-ANOMALY-',
    alternativeCodes: ['ANOMALY'],
    label: '回報異常',
    description: '下一件掃描的商品將標記為異常，可選擇庫存類型與備註',
    i18nKey: 'operator.return_verification.special_barcodes.report_anomaly',
  },

  // 確認進入列印流程
  CONFIRM_PRINT: {
    code: '-CONFIRM-',
    alternativeCodes: [],
    label: '確認列印',
    description: '確認所有商品已檢查完畢，進入列印流程',
    i18nKey: 'operator.qc.special_barcodes.confirm_print',
  },
};

/**
 * 檢查給定的條碼是否為特殊條碼
 * @param {string} code - 要檢查的條碼
 * @returns {Object|null} - 如果是特殊條碼，返回對應的常數定義；否則返回 null
 */
export function getSpecialBarcode(code) {
  const normalizedCode = String(code || '').trim().toUpperCase();

  for (const [key, barcode] of Object.entries(SPECIAL_BARCODES)) {
    const mainCode = barcode.code.toUpperCase();
    const altCodes = barcode.alternativeCodes.map(c => c.toUpperCase());

    if (normalizedCode === mainCode || altCodes.includes(normalizedCode)) {
      return { key, ...barcode };
    }
  }

  return null;
}

/**
 * 檢查是否為裝箱條碼
 * @param {string} code - 要檢查的條碼
 * @returns {boolean}
 */
export function isDoParcelBarcode(code) {
  const special = getSpecialBarcode(code);
  return special?.key === 'DO_PACKING';
}

/**
 * 檢查是否為確認列印條碼
 * @param {string} code - 要檢查的條碼
 * @returns {boolean}
 */
/**
 * 檢查是否為回報異常條碼
 * @param {string} code - 要檢查的條碼
 * @returns {boolean}
 */
export function isReportAnomalyBarcode(code) {
  const special = getSpecialBarcode(code);
  return special?.key === 'REPORT_ANOMALY';
}

export function isConfirmPrintBarcode(code) {
  const special = getSpecialBarcode(code);
  return special?.key === 'CONFIRM_PRINT';
}
